import { useCallback, useState } from 'react';

export default function useGenAiChat() {
  const [isGenAiChatOpen, setIsGenAiChatOpen] = useState(false);
  const [selectedNexsetIdForGenAiChat, setSelectedNexsetIdForGenAiChat] = useState('');
  const [originNodeId, setOriginNodeId] = useState('');

  const handleOpenGenAiChat = useCallback(
    (nexsetId: string, origin_node_id?: string) => {
      if (isGenAiChatOpen) {
        setIsGenAiChatOpen(false);
        setTimeout(() => {
          setSelectedNexsetIdForGenAiChat(nexsetId);
          if (origin_node_id) {
            setOriginNodeId(origin_node_id);
          }

          setIsGenAiChatOpen(true);
        }, 500);
      } else {
        setSelectedNexsetIdForGenAiChat(nexsetId);
        if (origin_node_id) {
          setOriginNodeId(origin_node_id);
        }

        setIsGenAiChatOpen(true);
      }
    },
    [isGenAiChatOpen],
  );
  const handleCloseGenAiChat = useCallback(() => {
    setSelectedNexsetIdForGenAiChat(null);
    setOriginNodeId(null);
    setIsGenAiChatOpen(false);
  }, []);

  return {
    isGenAiChatOpen,
    setIsGenAiChatOpen,
    selectedNexsetIdForGenAiChat,
    setSelectedNexsetIdForGenAiChat,
    handleOpenGenAiChat,
    originNodeId,
    setOriginNodeId,
    handleCloseGenAiChat,
  };
}
